export default __webpack_public_path__ + "static/media/ctError.3bd9e27c.png";